import { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";
import { locationSchema } from "./location-state-schema.ts";

// subSchemas //

export const brokerSchema = idNameSchema.extend({
	email: z.string().email().nullable(),
});

// GET Request Schemas //

//Endpoint: /api/create-quote/customers?nameBeginsWith={:userTypedString}
export const customerSchema = idNameSchema.extend({
	hasSignedLTLAddendum: z.boolean(),
	status: idNameSchema,
	nameWithId: z.string().optional(),
});

//Endpoint: /api/create-quote/account-reps?brokerId={:brokerId}&mode={:modeString}&customerId={:customerId}
// Endpoint: /api/create-quote/customers/{:customerId}
export const customerDetailsSchema = customerSchema.extend({
	primaryBroker: brokerSchema.nullable(),
	ltlBroker: brokerSchema.nullable(),
});
// .omit({
// 	name: true,
// });

export const freightCustomerSchema = z.object({
	customerId: z.number(),
	customerName: z.string(),
	ftCustomerId: z.number(),
	orderBy: z.number(),
});

export const primaryBrokerSchema = brokerSchema.extend({
	mode: z.string(),
	isBackup: z.boolean(),
});

export const mockCustomerSchema = z.object({
	id: z.number(),
	customer: z.string(),
	customerStatus: z.string(),
	primary: z.string(),
	ltl: z.string(),
	origin: z.string(),
	destination: z.string(),
	equipment: z.string(),
	rate: z.string(),
	status: z.string(),
	expiryDate: z.string(),
});

// Endpoint: /api/carrier-selection/credit-info?customerId=584182
export const creditLimitSchema = z.object({
	creditLimit: z.number(),
	availableCredit: z.number(),
	totalBalance: z.number(),
});

export const contactDetailSchema = z.object({
	userId: z.number(),
	primaryExtension: z.string().nullable(),
});

export const sendCustomerEmailSchema = z.object({
	origin: locationSchema,
	destination: locationSchema,
	customer: customerDetailsSchema
		.omit({
			id: true,
			hasSignedLTLAddendum: true,
		})
		.extend({
			email: z.string(),
		}),
	quoteId: z.number(),
	payment: z.any().nullable(),
	toEmails: z.array(z.string()),
	tqlPO: z.number(),
	customerCost: z.number(),
	bolEmailBody: z.string(),
});

export const ltlOwnerSchema = z.object({
	userId: z.number(),
	name: z.string(),
	email: z.string(),
	extension: z.string(),
});

export const laeSchema = z.object({
	id: z.number(),
	costCenter: z.string().nullable(),
	costCenterDescription: z.string().nullable(),
	email: z.string().nullable(),
	extension: z.string().nullable(),
	jobCode: z.string().nullable(),
	name: z.string(),
	salesRegion: z.string().nullable(),
	salesTeam: z.string().nullable(),
	startDate: z.string().nullable(),
	title: z.string().nullable(),
	ftlRole: z.boolean().nullable(),
	ltlRole: z.boolean().nullable(),
	mexicoRole: z.boolean().nullable(),
	imdlRole: z.boolean().nullable(),
	drayageRole: z.boolean().nullable(),
	dropTrailerRole: z.boolean().nullable(),
	osowRole: z.boolean().nullable(),
	globalRole: z.boolean().nullable(),
	airRole: z.boolean().nullable(),
	oceanRole: z.boolean().nullable(),
	airOceanRole: z.boolean().nullable(),
	partialRole: z.boolean().nullable(),
	salesLeadId: z.number().nullable(),
	supervisorUserId: z.string().nullable(),
});

export type Customer = z.infer<typeof customerSchema>;
export type CustomerDetails = z.infer<typeof customerDetailsSchema>;
export type Broker = z.infer<typeof brokerSchema>;
export type PrimaryBroker = z.infer<typeof primaryBrokerSchema>;
export type CustomerMock = z.infer<typeof mockCustomerSchema>;
export type CreditLimit = z.infer<typeof creditLimitSchema>;
export type ContactDetail = z.infer<typeof contactDetailSchema>;
export type FreightCustomer = z.infer<typeof freightCustomerSchema>;
export type LtlOwner = z.infer<typeof ltlOwnerSchema>;
export type Lae = z.infer<typeof laeSchema>;
